// src/components/portfolio/add-asset/services/SearchService.js
import { BistService } from './BistService';
import { TefasService } from './TefasService';

export class SearchService {
  static async searchCurrencies(query) {
    const currencies = [
      { symbol: 'USD', name: 'Amerikan Doları', currencySymbol: '$' },
      { symbol: 'EUR', name: 'Euro', currencySymbol: '€' },
      { symbol: 'GBP', name: 'İngiliz Sterlini', currencySymbol: '£' },
      { symbol: 'TRY', name: 'Türk Lirası', currencySymbol: '₺' },
      { symbol: 'JPY', name: 'Japon Yeni', currencySymbol: '¥' },
      { symbol: 'CHF', name: 'İsviçre Frangı', currencySymbol: 'Fr' },
      { symbol: 'AUD', name: 'Avustralya Doları', currencySymbol: 'A$' },
      { symbol: 'CAD', name: 'Kanada Doları', currencySymbol: 'C$' }
    ];
    
    return currencies.filter(curr => 
      curr.symbol.toLowerCase().includes(query.toLowerCase()) || 
      curr.name.toLowerCase().includes(query.toLowerCase())
    );
  }

  static async searchLocal(searchQuery, db, searchMode) {
    if (searchQuery.length < 2) return [];

    try {
      switch (searchMode) {
 
        case 'fund':
          return await TefasService.searchFunds(searchQuery);
        case 'local':
          return await BistService.searchStocks(searchQuery);
        case 'api':
          return await this.searchGlobal(searchQuery);
        default:
          return [];
      }
    } catch (error) {
      console.error('Arama hatası:', error);
      return [];
    }
  }

  static async searchGlobal(query) {
    if (query.length < 2) return [];

    try {
      const response = await fetch(
        `https://autocomplete.tipranks.com/api/autocomplete/search?name=${query}&topAnalysts=3&topInsiders=3&topInstitutions=3&topBloggers=3&topTickers=6&onlyStockTickers=false&ignoreFunds=false`
      );

      if (!response.ok) {
        throw new Error('TipRanks API yanıt vermedi');
      }

      const data = await response.json();
      
      return data
        .filter(item => item.category === 'ticker' || item.category === 'etf')
        .map(item => ({
          symbol: item.value,
          name: item.label,
          type: item.category === 'etf' ? 'ETF' : 'STOCK',
          exchange: item.extraData?.market || '',
          exchangeShortName: item.extraData?.market || '',
          description: item.label
        }));
    } catch (error) {
      console.error('TipRanks API hatası:', error);
      return [];
    }
  }
}